import { useEffect, useContext } from 'react';
import log from './ChatDebug';
import createChatConfig from './ChatConfig';
import { tabletUpper } from '../../utils/device/viewPortWidths';
import EnvVarsFeaturesContext from '../../scaffold/EnvVarsFeaturesContext';

let CHAT_JLP_URL;
let CHAT_JLP_URL_CUSTOMER_SERVICE;
let CHAT_URL;
let CHAT_CLIENT_ID;
let CHAT_CONTENT_URL;
let CHAT_DEPLOYMENT_ID;
let CHAT_BASELINE_AGENT_URL;
let CHAT_SCRIPT_URL;

const initChat = (
  url,
  categoryName,
  buttonId,
  eswLiveAgentDevName,
  chatLabel
) => {
  const embeddedSvc = window.embedded_svc;

  log(
    'Init chat with : ',
    `url: ${url}`,
    `categoryName: ${categoryName}`,
    `buttonId: ${buttonId}`,
    `eswLiveAgentDevName: ${eswLiveAgentDevName}`,
    `chatLabel: ${chatLabel}`
  );

  embeddedSvc.settings.displayHelpButton = true;
  embeddedSvc.settings.language = '';
  embeddedSvc.settings.enabledFeatures = ['LiveAgent'];
  embeddedSvc.settings.entryFeature = 'LiveAgent';
  embeddedSvc.settings.defaultMinimizedText = chatLabel;
  embeddedSvc.init(
    CHAT_JLP_URL,
    CHAT_JLP_URL_CUSTOMER_SERVICE,
    url,
    CHAT_CLIENT_ID,
    categoryName,
    {
      baseLiveAgentContentURL: CHAT_CONTENT_URL,
      deploymentId: CHAT_DEPLOYMENT_ID,
      buttonId,
      baseLiveAgentURL: CHAT_BASELINE_AGENT_URL,
      eswLiveAgentDevName,
      isOfflineSupportEnabled: false,
    }
  );

  embeddedSvc.settings.extraPrechatInfo = [
    {
      entityFieldMaps: [
        {
          doCreate: false,
          doFind: true,
          fieldName: 'Shopper_ID__c',
          isExactMatch: true,
          label: 'shopperId',
        },
      ],
      entityName: 'Contact',
      saveToTranscript: 'ContactId',
    },
  ];
  embeddedSvc.addEventHandler('onHelpButtonClick', () => {
    const shopperIdCookie = document.cookie.match(
      new RegExp('(^| )shopperId=([^;]+)')
    );
    if (shopperIdCookie) {
      window.embedded_svc.settings.extraPrechatFormDetails = [
        { label: 'shopperId', value: shopperIdCookie[2], displayToAgent: true },
      ];
    }
  });
};

const loadChatScript = () => {
  const body = document.getElementsByTagName('body').item(0);
  const script = document.createElement('script');
  script.setAttribute('type', 'text/javascript');
  script.setAttribute('src', `${CHAT_SCRIPT_URL}`);
  script.setAttribute('defer', 'defer');
  body.appendChild(script);
  return script;
};

const loadStyles = () => {
  const css =
    'button.helpButtonDisabled {display: none !important;} \n' +
    'button.helpButtonEnabled {display: flex !important;}';
  const head = document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  head.appendChild(style);
};

const loadInitialState = () => {
  const chatConfig = createChatConfig();
  log('Load chatConfig', chatConfig);
  if (chatConfig && chatConfig.length === 1) {
    const script = loadChatScript();
    loadStyles();
    script.onload = () => {
      const url = window.embedded_svc ? CHAT_URL : null;
      const chatLabel =
        window.innerWidth < tabletUpper && chatConfig[0].mobileChatLabel
          ? chatConfig[0].mobileChatLabel
          : chatConfig[0].chatLabel;
      log('Chat label: ', chatLabel);
      initChat(
        url,
        chatConfig[0].categoryName,
        chatConfig[0].buttonId,
        chatConfig[0].agentDevName,
        chatLabel
      );
    };
  }
};

const Chat = () => {
  const {
    envVars: {
      chatJlpUrl,
      chatJlpUrlCustomerService,
      chatUrl,
      chatClientId,
      chatContentUrl,
      chatDeploymentId,
      chatBaselineAgentUrl,
      chatScriptUrl,
    },
  } = useContext(EnvVarsFeaturesContext);

  useEffect(() => {
    CHAT_JLP_URL = chatJlpUrl;
    CHAT_JLP_URL_CUSTOMER_SERVICE = chatJlpUrlCustomerService;
    CHAT_URL = chatUrl;
    CHAT_CLIENT_ID = chatClientId;
    CHAT_CONTENT_URL = chatContentUrl;
    CHAT_DEPLOYMENT_ID = chatDeploymentId;
    CHAT_BASELINE_AGENT_URL = chatBaselineAgentUrl;
    CHAT_SCRIPT_URL = chatScriptUrl;
    const isBrowser = !!global.window;
    if (isBrowser) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', loadInitialState);
      } else {
        loadInitialState();
      }
    }
  }, []);
  return null;
};

export default Chat;
